import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRelatedBlogs } from "../../features/relatedBlogs/relatedBlogsSlice";
import Loading from "../UI/Loading";
import RelatedBlogCard from "./RelatedBlogCard";

const RelatedBlogs = ({ currentBlogId, tags }) => {
  const dispatch = useDispatch();

  const { relatedBlogs, isLoading, isError, error } = useSelector(
    (state) => state.relatedBlogs
  );

  useEffect(() => {
    dispatch(fetchRelatedBlogs({ id: currentBlogId, tags }));
  }, [dispatch, currentBlogId, tags]);

  // deside what to render
  let content = null;
  if (isLoading) content = <Loading />;

  if (!isLoading && isError)
    content = <div className="col-span-12">{error}</div>;

  if (!isLoading && !isError && relatedBlogs?.length === 0)
    content = <div className="col-span-12">No Related Blog Found!</div>;

  if (!isLoading && !isError && relatedBlogs?.length > 0)
    content = relatedBlogs.map((blog) => (
      <RelatedBlogCard blog={blog} key={blog.id} />
    ));

  return (
    <aside>
      <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">
        Related Posts
      </h4>
      <div className="space-y-4 related-post-container">{content}</div>
    </aside>
  );
};

export default RelatedBlogs;
